import { Directive } from '@angular/core';
import { getISOWeek } from 'date-fns';
import { injectDatePickerWeek } from 'ng-primitives/date-picker';

/**
 * Renders the ISO week number for a calendar row.
 *
 * Sits on the leading `<td>` of a `*ngpDatePickerRowRender` row. The row's
 * embedded view provides `NgpDatePickerWeekToken` (the seven dates of that
 * week) on its injector, so `injectDatePickerWeek()` resolves here. Exposed via
 * `exportAs` so the template reads `{{ wk.weekNo }}`.
 */
@Directive({
  selector: '[suiCalendarWeekNumber]',
  standalone: true,
  exportAs: 'suiCalendarWeekNumber',
})
export class SuiCalendarWeekNumberDirective {
  private readonly week = injectDatePickerWeek<Date>();

  /** ISO 8601 week number (Monday-based) of this row. */
  get weekNo(): number {
    return getISOWeek(this.week[0]);
  }
}
